import type { Variant } from '../codegen/types';

export function findMostExpensiveSku({ variants }: { variants?: Variant[] }) {
  return variants
    ?.flatMap((variant) => variant.price)
    .sort((a, b) => b.actualPrice.centAmount - a.actualPrice.centAmount)?.[0];
}

export const roundSaleBadgeValue = (code: string): number => Math.floor(Number.parseFloat(code));
